export const DIAGNOSES_LOCATION_ID = 'locationId';
export const DIAGNOSES_MORPHOLOGY_ID = 'morphologyId';
export const DIAGNOSES_DIAMETER_MM_ID = 'diameterMmId';
export const DIAGNOSES_RESULT_ID = 'resultId';
export const DIAGNOSES_BY_ID = 'diagnosisDoneById';
export const DIAGNOSES_BY_NAME = 'diagnosisDoneByName';
export const MUTATION_HISTOLOGICAL_DIAGNOSIS = 'mutationHistologicalDiagnosis';
